import { userOnboardingStage } from "app/types";
import { IMySettingTypeState } from "../types";
import { defaultAvatar } from "../../../redux/initialState";

export const initialState: IMySettingTypeState = {
  form: {
    _id: "",
    createdAt: "",
    updatedAt: "",
    email: "",
    signup: [],
    isActive: false,
    avatar: { ...defaultAvatar },
    userOnboardingProgress: userOnboardingStage.CODE_VERIFICATION,
    language: "",
    timeFormat: "",
    dateFormat: "",
    weekStart: "",
    fullName: "",
    timeZone: "",
    hasPassword: true,
    oldEmail: {
      value: "",
      error: "",
    },
    newEmail: {
      value: "",
      error: "",
    },
    oldPassword: {
      value: "",
      error: "",
    },
    newPassword: {
      value: "",
      error: "",
    },
    confirmPassword: {
      value: "",
      error: "",
    },
    mobileNumber: "",
  },
  isLoading: false,
  hasPassword: false,
  buttonLoading: false,
  verifyCodeError: "",
  changeEmailRequestId: "",
};
